import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BonusApi } from 'src/app/shared/apis/bonus.api';

@Injectable({
  providedIn: 'root',
})
export class CardCenterService {
  constructor(private bonusApi: BonusApi) {}

  /**@bounsCount$ 订阅卡劵数量 */
  bounsCount$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  /**@getBounsCount 获取卡劵数量 */
  getBonusCount() {
    this.bonusApi.getBonusCount().subscribe(data => {
      this.bounsCount$.next(data);
    });
  }
}
